// extracted by mini-css-extract-plugin
export default {"title":"VideosView_title__Ma0+P","btn":"VideosView_btn__k4NGS"};